/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section6_TitleInputs */

const en_privacy_section6_title = /** @type {(inputs: Privacy_Section6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changes to This Policy`)
};

const ko_privacy_section6_title = /** @type {(inputs: Privacy_Section6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`정책 변경`)
};

const ja_privacy_section6_title = /** @type {(inputs: Privacy_Section6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ポリシーの変更`)
};

/**
* | output |
* | --- |
* | "Changes to This Policy" |
*
* @param {Privacy_Section6_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const privacy_section6_title = /** @type {((inputs?: Privacy_Section6_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section6_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_section6_title(inputs)
	if (locale === "ko") return ko_privacy_section6_title(inputs)
	return ja_privacy_section6_title(inputs)
});